import { render, staticRenderFns } from "./goodsInStock.vue?vue&type=template&id=3930316c&scoped=true&"
import script from "./goodsInStock.vue?vue&type=script&lang=js&"
export * from "./goodsInStock.vue?vue&type=script&lang=js&"
import style0 from "./goodsInStock.vue?vue&type=style&index=0&id=3930316c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930316c",
  null
  
)

export default component.exports